import { ItemScheme } from '../../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../../Enums/MagicField.enum';

const firstMonth: ItemScheme[] = [
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamVaginalBleeding',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.vaginalBleeding',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				value: 'meddiBabyLatamVaginalBleeding',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamTemperature',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.temperature',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamTemperature',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamWeight',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.weight',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamWeight',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamUrinaryTractInfection',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.signsOfUrinaryInfection',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamUrinaryTractInfection',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamVaginalInfection',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.signsOfVaginalInfection',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamVaginalInfection',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamVomiting',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.vomiting',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamVomiting',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamDiarrhoea',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.diarrhealPictures',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamDiarrhoea',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamSwelling',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.edema',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamSwelling',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamMedicaments',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.medicationReaction',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamMedicaments',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamBloodpresure',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.arterialPressure.text',
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamBloodpresure',
			},
			{
				type: MagicField.CONDITION,
				value: 'meddiBabyLatamBloodpresure.toggle',
				settings: {
					rules: [
						{
							formControlKey: 'meddiBabyLatamBloodpresure.toggle',
							rule: 'equal',
							value: true,
						},
					],
				},
				children: [
					{
						type: MagicField.CONTAINER,
						settings: {
							showLine: true,
						},
						children: [
							{
								type: MagicField.RADIOLIST,
								key: 'frequency',
								settings: {
									required: true,
								},
								children: [
									{
										value: '15days7am',
										title:
											'component.monitoring.baby.arterialPressure.15days7am',
									},
									{
										value: 'weekWed7am2pm9pm',
										title:
											'component.monitoring.baby.arterialPressure.onceAWeek',
									},
									{
										value: 'weekMonWedFri7am2pm9pm',
										title:
											'component.monitoring.baby.arterialPressure.thriceAWeek',
									},
									{
										value: 'daily7am2pm9pm',
										title: 'component.monitoring.baby.arterialPressure.daily',
									},
								],
							},
						],
					},
				],
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamGlycemia',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.glycemia.text',
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamGlycemia',
			},
			{
				type: MagicField.CONDITION,
				value: 'meddiBabyLatamGlycemia.toggle',
				settings: {
					rules: [
						{
							formControlKey: 'meddiBabyLatamGlycemia.toggle',
							rule: 'equal',
							value: true,
						},
					],
				},
				children: [
					{
						type: MagicField.CONTAINER,
						settings: {
							showLine: true,
						},
						children: [
							{
								type: MagicField.RADIOLIST,
								key: 'frequency',
								settings: {
									required: true,
								},
								children: [
									{
										value: '15days7am',
										title: 'component.monitoring.baby.glycemia.15days7am',
									},
									{
										value: 'weekWed7am',
										title: 'component.monitoring.baby.glycemia.onceAWeek',
									},
									{
										value: 'weekMonWedFri7am',
										title: 'component.monitoring.baby.glycemia.thriceAWeek',
									},
									{
										value: 'daily7am',
										title: 'component.monitoring.baby.glycemia.daily',
									},
								],
							},
						],
					},
				],
			},
		],
	},
];

const secondMonth: ItemScheme[] = [
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamVaginalBleeding',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.vaginalBleeding',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				value: 'meddiBabyLatamVaginalBleeding',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamTemperature',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.temperature',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamTemperature',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamWeight',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.weight',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamWeight',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamUrinaryTractInfection',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.signsOfUrinaryInfection',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamUrinaryTractInfection',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamVaginalInfection',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.signsOfVaginalInfection',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamVaginalInfection',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamVomiting',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.vomiting',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamVomiting',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamDiarrhoea',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.diarrhealPictures',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamDiarrhoea',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamSwelling',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.edema',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamSwelling',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamMedicaments',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.medicationReaction',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamMedicaments',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamBloodpresure',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.arterialPressure.text',
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamBloodpresure',
			},
			{
				type: MagicField.CONDITION,
				value: 'meddiBabyLatamBloodpresure.toggle',
				settings: {
					rules: [
						{
							formControlKey: 'meddiBabyLatamBloodpresure.toggle',
							rule: 'equal',
							value: true,
						},
					],
				},
				children: [
					{
						type: MagicField.CONTAINER,
						settings: {
							showLine: true,
						},
						children: [
							{
								type: MagicField.RADIOLIST,
								key: 'frequency',
								settings: {
									required: true,
								},
								children: [
									{
										value: '15days7am',
										title:
											'component.monitoring.baby.arterialPressure.15days7am',
									},
									{
										value: 'weekWed7am2pm9pm',
										title:
											'component.monitoring.baby.arterialPressure.onceAWeek',
									},
									{
										value: 'weekMonWedFri7am2pm9pm',
										title:
											'component.monitoring.baby.arterialPressure.thriceAWeek',
									},
									{
										value: 'daily7am2pm9pm',
										title: 'component.monitoring.baby.arterialPressure.daily',
									},
								],
							},
						],
					},
				],
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamGlycemia',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.glycemia.text',
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamGlycemia',
			},
			{
				type: MagicField.CONDITION,
				value: 'meddiBabyLatamGlycemia.toggle',
				settings: {
					rules: [
						{
							formControlKey: 'meddiBabyLatamGlycemia.toggle',
							rule: 'equal',
							value: true,
						},
					],
				},
				children: [
					{
						type: MagicField.CONTAINER,
						settings: {
							showLine: true,
						},
						children: [
							{
								type: MagicField.RADIOLIST,
								key: 'frequency',
								settings: {
									required: true,
								},
								children: [
									{
										value: '15days7am',
										title: 'component.monitoring.baby.glycemia.15days7am',
									},
									{
										value: 'weekWed7am',
										title: 'component.monitoring.baby.glycemia.onceAWeek',
									},
									{
										value: 'weekMonWedFri7am',
										title: 'component.monitoring.baby.glycemia.thriceAWeek',
									},
									{
										value: 'daily7am',
										title: 'component.monitoring.baby.glycemia.daily',
									},
								],
							},
						],
					},
				],
			},
		],
	},
];

const thirdMonth: ItemScheme[] = [
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamVaginalBleeding',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.vaginalBleeding',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				value: 'meddiBabyLatamVaginalBleeding',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamTemperature',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.temperature',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamTemperature',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamWeight',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.weight',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamWeight',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamUrinaryTractInfection',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.signsOfUrinaryInfection',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamUrinaryTractInfection',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamVaginalInfection',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.signsOfVaginalInfection',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamVaginalInfection',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamVomiting',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.vomiting',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamVomiting',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamDiarrhoea',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.diarrhealPictures',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamDiarrhoea',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamSwelling',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.edema',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamSwelling',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamMedicaments',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.medicationReaction',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamMedicaments',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamBloodpresure',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.arterialPressure.text',
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamBloodpresure',
			},
			{
				type: MagicField.CONDITION,
				value: 'meddiBabyLatamBloodpresure.toggle',
				settings: {
					rules: [
						{
							formControlKey: 'meddiBabyLatamBloodpresure.toggle',
							rule: 'equal',
							value: true,
						},
					],
				},
				children: [
					{
						type: MagicField.CONTAINER,
						settings: {
							showLine: true,
						},
						children: [
							{
								type: MagicField.RADIOLIST,
								key: 'frequency',
								settings: {
									required: true,
								},
								children: [
									{
										value: '15days7am',
										title:
											'component.monitoring.baby.arterialPressure.15days7am',
									},
									{
										value: 'weekWed7am2pm9pm',
										title:
											'component.monitoring.baby.arterialPressure.onceAWeek',
									},
									{
										value: 'weekMonWedFri7am2pm9pm',
										title:
											'component.monitoring.baby.arterialPressure.thriceAWeek',
									},
									{
										value: 'daily7am2pm9pm',
										title: 'component.monitoring.baby.arterialPressure.daily',
									},
								],
							},
						],
					},
				],
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamGlycemia',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.glycemia.text',
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamGlycemia',
			},
			{
				type: MagicField.CONDITION,
				value: 'meddiBabyLatamGlycemia.toggle',
				settings: {
					rules: [
						{
							formControlKey: 'meddiBabyLatamGlycemia.toggle',
							rule: 'equal',
							value: true,
						},
					],
				},
				children: [
					{
						type: MagicField.CONTAINER,
						settings: {
							showLine: true,
						},
						children: [
							{
								type: MagicField.RADIOLIST,
								key: 'frequency',
								settings: {
									required: true,
								},
								children: [
									{
										value: '15days7am',
										title: 'component.monitoring.baby.glycemia.15days7am',
									},
									{
										value: 'weekWed7am',
										title: 'component.monitoring.baby.glycemia.onceAWeek',
									},
									{
										value: 'weekMonWedFri7am',
										title: 'component.monitoring.baby.glycemia.thriceAWeek',
									},
									{
										value: 'daily7am',
										title: 'component.monitoring.baby.glycemia.daily',
									},
								],
							},
						],
					},
				],
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamHypertensionSymptoms',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.hypertensionSymptoms.text',
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamHypertensionSymptoms',
			},
			{
				type: MagicField.CONDITION,
				value: 'meddiBabyLatamHypertensionSymptoms.toggle',
				settings: {
					rules: [
						{
							formControlKey: 'meddiBabyLatamHypertensionSymptoms.toggle',
							rule: 'equal',
							value: true,
						},
					],
				},
				children: [
					{
						type: MagicField.CONTAINER,
						settings: {
							showLine: true,
						},
						children: [
							{
								type: MagicField.RADIOLIST,
								key: 'frequency',
								settings: {
									required: true,
								},
								children: [
									{
										value: '15days7am',
										title:
											'component.monitoring.baby.hypertensionSymptoms.15days7am',
									},
									{
										value: 'weekWed7am2pm9pm',
										title:
											'component.monitoring.baby.hypertensionSymptoms.onceAWeek',
									},
									{
										value: 'weekMonWedFri7am2pm9pm',
										title:
											'component.monitoring.baby.hypertensionSymptoms.thriceAWeek',
									},
									{
										value: 'daily7am2pm9pm',
										title:
											'component.monitoring.baby.hypertensionSymptoms.daily',
									},
								],
							},
						],
					},
				],
			},
		],
	},
];

const fourthMonth: ItemScheme[] = [...thirdMonth];

const fifthMonth: ItemScheme[] = [...fourthMonth];

const sixthMonth: ItemScheme[] = [
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamVaginalBleeding',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.vaginalBleeding',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				value: 'meddiBabyLatamVaginalBleeding',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamTemperature',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.temperature',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamTemperature',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamWeight',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.weight',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamWeight',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamUrinaryTractInfection',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.signsOfUrinaryInfection',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamUrinaryTractInfection',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamVaginalInfection',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.signsOfVaginalInfection',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamVaginalInfection',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamVomiting',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.vomiting',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamVomiting',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamDiarrhoea',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.diarrhealPictures',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamDiarrhoea',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamSwelling',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.edema',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamSwelling',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamMedicaments',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.medicationReaction',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamMedicaments',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamBloodpresure',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.arterialPressure.text',
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamBloodpresure',
			},
			{
				type: MagicField.CONDITION,
				value: 'meddiBabyLatamBloodpresure.toggle',
				settings: {
					rules: [
						{
							formControlKey: 'meddiBabyLatamBloodpresure.toggle',
							rule: 'equal',
							value: true,
						},
					],
				},
				children: [
					{
						type: MagicField.CONTAINER,
						settings: {
							showLine: true,
						},
						children: [
							{
								type: MagicField.RADIOLIST,
								key: 'frequency',
								settings: {
									required: true,
								},
								children: [
									{
										value: '15days7am',
										title:
											'component.monitoring.baby.arterialPressure.15days7am',
									},
									{
										value: 'weekWed7am2pm9pm',
										title:
											'component.monitoring.baby.arterialPressure.onceAWeek',
									},
									{
										value: 'weekMonWedFri7am2pm9pm',
										title:
											'component.monitoring.baby.arterialPressure.thriceAWeek',
									},
									{
										value: 'daily7am2pm9pm',
										title: 'component.monitoring.baby.arterialPressure.daily',
									},
								],
							},
						],
					},
				],
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamGlycemia',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.glycemia.text',
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamGlycemia',
			},
			{
				type: MagicField.CONDITION,
				value: 'meddiBabyLatamGlycemia.toggle',
				settings: {
					rules: [
						{
							formControlKey: 'meddiBabyLatamGlycemia.toggle',
							rule: 'equal',
							value: true,
						},
					],
				},
				children: [
					{
						type: MagicField.CONTAINER,
						settings: {
							showLine: true,
						},
						children: [
							{
								type: MagicField.RADIOLIST,
								key: 'frequency',
								settings: {
									required: true,
								},
								children: [
									{
										value: '15days7am',
										title: 'component.monitoring.baby.glucose.15days7am',
									},
									{
										value: 'weekWed7am',
										title: 'component.monitoring.baby.glucose.onceAWeek',
									},
									{
										value: 'weekMonWedFri7am',
										title: 'component.monitoring.baby.glucose.thriceAWeek',
									},
									{
										value: 'daily7am',
										title: 'component.monitoring.baby.glucose.daily',
									},
								],
							},
						],
					},
				],
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamHypertensionSymptoms',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.hypertensionSymptoms.text',
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamHypertensionSymptoms',
			},
			{
				type: MagicField.CONDITION,
				value: 'meddiBabyLatamHypertensionSymptoms.toggle',
				settings: {
					rules: [
						{
							formControlKey: 'meddiBabyLatamHypertensionSymptoms.toggle',
							rule: 'equal',
							value: true,
						},
					],
				},
				children: [
					{
						type: MagicField.CONTAINER,
						settings: {
							showLine: true,
						},
						children: [
							{
								type: MagicField.RADIOLIST,
								key: 'frequency',
								settings: {
									required: true,
								},
								children: [
									{
										value: '15days7am',
										title:
											'component.monitoring.baby.hypertensionSymptoms.15days7am',
									},
									{
										value: 'weekWed7am2pm9pm',
										title:
											'component.monitoring.baby.hypertensionSymptoms.onceAWeek',
									},
									{
										value: 'weekMonWedFri7am2pm9pm',
										title:
											'component.monitoring.baby.hypertensionSymptoms.thriceAWeek',
									},
									{
										value: 'daily7am2pm9pm',
										title:
											'component.monitoring.baby.hypertensionSymptoms.daily',
									},
								],
							},
						],
					},
				],
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamAmnioticFluidLeak',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.amnioticFluidLeak',
				defaultValue: true,
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamAmnioticFluidLeak',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamFetalMovements',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.fetalMovements',
				defaultValue: true,
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamFetalMovements',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamUterineContractions',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.uterineContractions',
				defaultValue: true,
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamUterineContractions',
			},
		],
	},
];

const seventhMonth: ItemScheme[] = [
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamVaginalBleeding',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.vaginalBleeding',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.7days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				value: 'meddiBabyLatamVaginalBleeding',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamTemperature',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.temperature',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.7days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamTemperature',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamWeight',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.weight',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.7days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamWeight',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamUrinaryTractInfection',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.signsOfUrinaryInfection',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.7days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamUrinaryTractInfection',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamVaginalInfection',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.signsOfVaginalInfection',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.7days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamVaginalInfection',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamVomiting',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.vomiting',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.7days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamVomiting',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamDiarrhoea',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.diarrhealPictures',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.7days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamDiarrhoea',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamSwelling',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.edema',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.7days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamSwelling',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamMedicaments',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.medicationReaction',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.7days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamMedicaments',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamBloodpresure',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.arterialPressure.text',
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamBloodpresure',
			},
			{
				type: MagicField.CONDITION,
				value: 'meddiBabyLatamBloodpresure.toggle',
				settings: {
					rules: [
						{
							formControlKey: 'meddiBabyLatamBloodpresure.toggle',
							rule: 'equal',
							value: true,
						},
					],
				},
				children: [
					{
						type: MagicField.CONTAINER,
						settings: {
							showLine: true,
						},
						children: [
							{
								type: MagicField.RADIOLIST,
								key: 'frequency',
								settings: {
									required: true,
								},
								children: [
									{
										value: '7days7am',
										title:
											'component.monitoring.baby.arterialPressure.7days7am',
									},
									{
										value: 'weekWed7am2pm9pm',
										title:
											'component.monitoring.baby.arterialPressure.onceAWeek',
									},
									{
										value: 'weekMonWedFri7am2pm9pm',
										title:
											'component.monitoring.baby.arterialPressure.thriceAWeek',
									},
									{
										value: 'daily7am2pm9pm',
										title: 'component.monitoring.baby.arterialPressure.daily',
									},
								],
							},
						],
					},
				],
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamGlycemia',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.glycemia.text',
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamGlycemia',
			},
			{
				type: MagicField.CONDITION,
				value: 'meddiBabyLatamGlycemia.toggle',
				settings: {
					rules: [
						{
							formControlKey: 'meddiBabyLatamGlycemia.toggle',
							rule: 'equal',
							value: true,
						},
					],
				},
				children: [
					{
						type: MagicField.CONTAINER,
						settings: {
							showLine: true,
						},
						children: [
							{
								type: MagicField.RADIOLIST,
								key: 'frequency',
								settings: {
									required: true,
								},
								children: [
									{
										value: '7days7am',
										title: 'component.monitoring.baby.glucose.7days7am',
									},
									{
										value: 'weekWed7am',
										title: 'component.monitoring.baby.glucose.onceAWeek',
									},
									{
										value: 'weekMonWedFri7am',
										title: 'component.monitoring.baby.glucose.thriceAWeek',
									},
									{
										value: 'daily7am',
										title: 'component.monitoring.baby.glucose.daily',
									},
								],
							},
						],
					},
				],
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamHypertensionSymptoms',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.hypertensionSymptoms.text',
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamHypertensionSymptoms',
			},
			{
				type: MagicField.CONDITION,
				value: 'meddiBabyLatamHypertensionSymptoms.toggle',
				settings: {
					rules: [
						{
							formControlKey: 'meddiBabyLatamHypertensionSymptoms.toggle',
							rule: 'equal',
							value: true,
						},
					],
				},
				children: [
					{
						type: MagicField.CONTAINER,
						settings: {
							showLine: true,
						},
						children: [
							{
								type: MagicField.RADIOLIST,
								key: 'frequency',
								settings: {
									required: true,
								},
								children: [
									{
										value: '7days7am',
										title:
											'component.monitoring.baby.hypertensionSymptoms.7days7am',
									},
									{
										value: 'weekWed7am2pm9pm',
										title:
											'component.monitoring.baby.hypertensionSymptoms.onceAWeek',
									},
									{
										value: 'weekMonWedFri7am2pm9pm',
										title:
											'component.monitoring.baby.hypertensionSymptoms.thriceAWeek',
									},
									{
										value: 'daily7am2pm9pm',
										title:
											'component.monitoring.baby.hypertensionSymptoms.daily',
									},
								],
							},
						],
					},
				],
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamAmnioticFluidLeak',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.amnioticFluidLeak',
				defaultValue: true,
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.7days',
					},
				},
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamAmnioticFluidLeak',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamFetalMovements',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.fetalMovements',
				defaultValue: true,
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.7days',
					},
				},
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamFetalMovements',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamUterineContractions',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.uterineContractions',
				defaultValue: true,
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.7days',
					},
				},
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamUterineContractions',
			},
		],
	},
];

const eighthMonth: ItemScheme[] = [
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamVaginalBleeding',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.vaginalBleeding',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.4days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				value: 'meddiBabyLatamVaginalBleeding',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamTemperature',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.temperature',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.4days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamTemperature',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamWeight',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.weight',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.4days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamWeight',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamUrinaryTractInfection',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.signsOfUrinaryInfection',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.4days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamUrinaryTractInfection',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamVaginalInfection',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.signsOfVaginalInfection',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.4days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamVaginalInfection',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamVomiting',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.vomiting',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.4days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamVomiting',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamDiarrhoea',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.diarrhealPictures',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.4days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamDiarrhoea',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamSwelling',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.edema',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.4days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamSwelling',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamMedicaments',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.medicationReaction',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.4days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamMedicaments',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamBloodpresure',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.arterialPressure.text',
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamBloodpresure',
			},
			{
				type: MagicField.CONDITION,
				value: 'meddiBabyLatamBloodpresure.toggle',
				settings: {
					rules: [
						{
							formControlKey: 'meddiBabyLatamBloodpresure.toggle',
							rule: 'equal',
							value: true,
						},
					],
				},
				children: [
					{
						type: MagicField.CONTAINER,
						settings: {
							showLine: true,
						},
						children: [
							{
								type: MagicField.RADIOLIST,
								key: 'frequency',
								settings: {
									required: true,
								},
								children: [
									{
										value: '4days7am',
										title:
											'component.monitoring.baby.arterialPressure.4days7am',
									},
									{
										value: 'weekWed7am2pm9pm',
										title:
											'component.monitoring.baby.arterialPressure.onceAWeek',
									},
									{
										value: 'weekMonWedFri7am2pm9pm',
										title:
											'component.monitoring.baby.arterialPressure.thriceAWeek',
									},
									{
										value: 'daily7am2pm9pm',
										title: 'component.monitoring.baby.arterialPressure.daily',
									},
								],
							},
						],
					},
				],
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamGlycemia',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.glycemia.text',
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamGlycemia',
			},
			{
				type: MagicField.CONDITION,
				value: 'meddiBabyLatamGlycemia.toggle',
				settings: {
					rules: [
						{
							formControlKey: 'meddiBabyLatamGlycemia.toggle',
							rule: 'equal',
							value: true,
						},
					],
				},
				children: [
					{
						type: MagicField.CONTAINER,
						settings: {
							showLine: true,
						},
						children: [
							{
								type: MagicField.RADIOLIST,
								key: 'frequency',
								settings: {
									required: true,
								},
								children: [
									{
										value: '4days7am',
										title: 'component.monitoring.baby.glucose.4days7am',
									},
									{
										value: 'weekWed7am',
										title: 'component.monitoring.baby.glucose.onceAWeek',
									},
									{
										value: 'weekMonWedFri7am',
										title: 'component.monitoring.baby.glucose.thriceAWeek',
									},
									{
										value: 'daily7am',
										title: 'component.monitoring.baby.glucose.daily',
									},
								],
							},
						],
					},
				],
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamHypertensionSymptoms',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.hypertensionSymptoms.text',
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamHypertensionSymptoms',
			},
			{
				type: MagicField.CONDITION,
				value: 'meddiBabyLatamHypertensionSymptoms.toggle',
				settings: {
					rules: [
						{
							formControlKey: 'meddiBabyLatamHypertensionSymptoms.toggle',
							rule: 'equal',
							value: true,
						},
					],
				},
				children: [
					{
						type: MagicField.CONTAINER,
						settings: {
							showLine: true,
						},
						children: [
							{
								type: MagicField.RADIOLIST,
								key: 'frequency',
								settings: {
									required: true,
								},
								children: [
									{
										value: '4days7am',
										title:
											'component.monitoring.baby.hypertensionSymptoms.4days7am',
									},
									{
										value: 'weekWed7am2pm9pm',
										title:
											'component.monitoring.baby.hypertensionSymptoms.onceAWeek',
									},
									{
										value: 'weekMonWedFri7am2pm9pm',
										title:
											'component.monitoring.baby.hypertensionSymptoms.thriceAWeek',
									},
									{
										value: 'daily7am2pm9pm',
										title:
											'component.monitoring.baby.hypertensionSymptoms.daily',
									},
								],
							},
						],
					},
				],
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamAmnioticFluidLeak',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.amnioticFluidLeak',
				defaultValue: true,
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.4days',
					},
				},
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamAmnioticFluidLeak',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamFetalMovements',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.fetalMovements',
				defaultValue: true,
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.4days',
					},
				},
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamFetalMovements',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamUterineContractions',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.uterineContractions',
				defaultValue: true,
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.4days',
					},
				},
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamUterineContractions',
			},
		],
	},
];

const ninthMonth: ItemScheme[] = [
	{
		type: MagicField.CHECKBOX,
		key: 'meddiBabyLatamLochia',
		title: 'component.monitoring.baby.lochia',
		settings: {
			tooltip: {
				content: 'component.monitoring.baby.frequency.15days',
			},
		},
		defaultValue: true,
	},
	{
		type: MagicField.CHECKBOX,
		key: 'meddiBabyLatamLowerAbdomenPain',
		title: 'component.monitoring.baby.lowerAbdomenPain',
		settings: {
			tooltip: {
				content: 'component.monitoring.baby.frequency.15days',
			},
		},
		defaultValue: true,
	},
	{
		type: MagicField.CHECKBOX,
		key: 'meddiBabyLatamRouteOfDelivery',
		title: 'component.monitoring.baby.routeOfDelivery',
		settings: {
			tooltip: {
				content: 'component.monitoring.baby.frequency.15days',
			},
		},
		defaultValue: true,
	},
	{
		type: MagicField.CHECKBOX,
		key: 'meddiBabyLatamUrinaryTractInfection',
		title: 'component.monitoring.baby.signsOfUrinaryInfection',
		settings: {
			tooltip: {
				content: 'component.monitoring.baby.frequency.15days',
			},
		},
		defaultValue: true,
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamSwelling',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.edema',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamSwelling',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamMedicaments',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.medicationReaction',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamMedicaments',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamBloodpresure',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.arterialPressure.text',
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamBloodpresure',
			},
			{
				type: MagicField.CONDITION,
				value: 'meddiBabyLatamBloodpresure.toggle',
				settings: {
					rules: [
						{
							formControlKey: 'meddiBabyLatamBloodpresure.toggle',
							rule: 'equal',
							value: true,
						},
					],
				},
				children: [
					{
						type: MagicField.CONTAINER,
						settings: {
							showLine: true,
						},
						children: [
							{
								type: MagicField.RADIOLIST,
								key: 'frequency',
								settings: {
									required: true,
								},
								children: [
									{
										value: '15days7am',
										title:
											'component.monitoring.baby.arterialPressure.15days7am',
									},
									{
										value: 'weekWed7am2pm9pm',
										title:
											'component.monitoring.baby.arterialPressure.onceAWeek',
									},
									{
										value: 'weekMonWedFri7am2pm9pm',
										title:
											'component.monitoring.baby.arterialPressure.thriceAWeek',
									},
									{
										value: 'daily7am2pm9pm',
										title: 'component.monitoring.baby.arterialPressure.daily',
									},
								],
							},
						],
					},
				],
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamGlycemia',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.glycemia.text',
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamGlycemia',
			},
			{
				type: MagicField.CONDITION,
				value: 'meddiBabyLatamGlycemia.toggle',
				settings: {
					rules: [
						{
							formControlKey: 'meddiBabyLatamGlycemia.toggle',
							rule: 'equal',
							value: true,
						},
					],
				},
				children: [
					{
						type: MagicField.CONTAINER,
						settings: {
							showLine: true,
						},
						children: [
							{
								type: MagicField.RADIOLIST,
								key: 'frequency',
								settings: {
									required: true,
								},
								children: [
									{
										value: '15days7am',
										title: 'component.monitoring.baby.glucose.15days7am',
									},
									{
										value: 'weekWed7am',
										title: 'component.monitoring.baby.glucose.onceAWeek',
									},
									{
										value: 'weekMonWedFri7am',
										title: 'component.monitoring.baby.glucose.thriceAWeek',
									},
									{
										value: 'daily7am',
										title: 'component.monitoring.baby.glucose.daily',
									},
								],
							},
						],
					},
				],
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamHypertensionSymptoms',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.hypertensionSymptoms.text',
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamHypertensionSymptoms',
			},
			{
				type: MagicField.CONDITION,
				value: 'meddiBabyLatamHypertensionSymptoms.toggle',
				settings: {
					rules: [
						{
							formControlKey: 'meddiBabyLatamHypertensionSymptoms.toggle',
							rule: 'equal',
							value: true,
						},
					],
				},
				children: [
					{
						type: MagicField.CONTAINER,
						settings: {
							showLine: true,
						},
						children: [
							{
								type: MagicField.RADIOLIST,
								key: 'frequency',
								settings: {
									required: true,
								},
								children: [
									{
										value: '15days7am',
										title:
											'component.monitoring.baby.hypertensionSymptoms.15days7am',
									},
									{
										value: 'weekWed7am2pm9pm',
										title:
											'component.monitoring.baby.hypertensionSymptoms.onceAWeek',
									},
									{
										value: 'weekMonWedFri7am2pm9pm',
										title:
											'component.monitoring.baby.hypertensionSymptoms.thriceAWeek',
									},
									{
										value: 'daily7am2pm9pm',
										title:
											'component.monitoring.baby.hypertensionSymptoms.daily',
									},
								],
							},
						],
					},
				],
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamBreastSelfAssessment',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.breastSelfAssessment',
				defaultValue: true,
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.4days',
					},
				},
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamBreastSelfAssessment',
			},
		],
	},
];

const tenthMonth: ItemScheme[] = [...firstMonth];

const eleventhMonth: ItemScheme[] = [
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamFeedingType',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.newborn.feedingType',
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamFeedingType',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamBreastFeedingProblems',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.newborn.breastFeedingProblems',
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamBreastFeedingProblems',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamSucking',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.newborn.sucking',
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamSucking',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamBabySkinColor',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.newborn.babySkinColor',
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamBabySkinColor',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamLossOfUmbilicalCord',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.newborn.lossOfUmbilicalCord',
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamLossOfUmbilicalCord',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamSkinAroundTheNavel',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.newborn.skinAroundTheNavel',
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamSkinAroundTheNavel',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamNewbornTemperature',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.newborn.temperature',
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamNewbornTemperature',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamStoolConsistency',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.newborn.stoolConsistency',
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamStoolConsistency',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamIrritability',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.newborn.irritability',
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamIrritability',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamNewbornVomiting',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.newborn.vomiting',
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamNewbornVomiting',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamTremors',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.newborn.tremors',
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamTremors',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamBreathingDifficulty',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.newborn.breathingDifficulty',
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamBreathingDifficulty',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamNewbornCough',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.newborn.cough',
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamNewbornCough',
			},
		],
	},
];

export default [
	firstMonth,
	secondMonth,
	thirdMonth,
	fourthMonth,
	fifthMonth,
	sixthMonth,
	seventhMonth,
	eighthMonth,
	ninthMonth,
	tenthMonth,
	eleventhMonth,
];
